import type { ProductModel } from 'redux/services/api.generated';

export interface UserClaim {
  type: string;
  value: string;
}

export enum DocumentLanguage {
  English = 'en',
  Norwegian = 'nb',
  Spanish = 'es',
  French = 'fr',
  German = 'de',
  Italian = 'it',
  Danish = 'da',
  Russian = 'ru',
  Swedish = 'sv',
  Portugese = 'pt',
  Arabic = 'ar',
  Chinese = 'zh',
}

export enum UpdateStatus {
  Loading = 'Loading',
  Success = 'Success',
  Error = 'Error',
}

export type EnhancedProduct = ProductModel & {
  state?: UpdateStatus;
};
